<template>
  <div>
    <el-col :span="24">
      <div
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <h5 class="text-white mt-3 ml-5">Project Instances</h5>
        <projectInstanceTable ref="grandchildComp5" :table-data="tableData.project_instance" />
      </div>

      <div
        v-loading="!!pendingByReport.verra_eq1"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Baseline Emission 1 (Eq1)</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ verraEqUpdatedAt("verra_eq1") }}
          </span>
        </div>
        <verraEq1 ref="grandchildComp" :table-data="verraEqResult('verra_eq1')" />
      </div>

      <div
        v-loading="!!pendingByReport.verra_eq4"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Project Emission 1 (Eq4)</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ verraEqUpdatedAt("verra_eq4") }}
          </span>
        </div>
        <verraEq4 ref="grandchildComp1" :table-data="verraEqResult('verra_eq4')" />
      </div>

      <div
        v-loading="!!pendingByReport.verra_eq5"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Project Emission 2 (Eq5)</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ verraEqUpdatedAt("verra_eq5") }}
          </span>
        </div>
        <verraEq5 ref="grandchildComp2" :table-data="verraEqResult('verra_eq5')" />
      </div>

      <div
        v-loading="!!pendingByReport.verra_eq7"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Project Emission 3 (Eq7)</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ verraEqUpdatedAt("verra_eq7") }}
          </span>
        </div>
        <verraEq7 ref="grandchildComp3" :table-data="verraEqResult('verra_eq7')" />
      </div>

      <div
        v-loading="!!pendingByReport.verra_eq9"
        class="row m-0 mt-20 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
        <div class="el-col el-col-24">
          <h5 class="text-white mt-3 ml-1">Project Emission 4 (Eq9)</h5>
          <span class="moderat-white-12 ml-1 mb-3">
            Last updated: {{ verraEqUpdatedAt("verra_eq9") }}
          </span>
        </div>
        <verraEq9 ref="grandchildComp4" :table-data="verraEqResult('verra_eq9')" />
      </div>


    </el-col>
  </div>
</template>

<script>
import verraEq1 from "./verraEq1.vue";
import verraEq4 from "./verraEq4.vue";
import verraEq5 from "./verraEq5.vue";
import verraEq7 from "./verraEq7.vue";
import verraEq9 from "./verraEq9.vue";
import projectInstanceTable from "./projectInstanceTable.vue";

export default {

  components: {
    verraEq1,
    verraEq4,
    verraEq5,
    verraEq7,
    verraEq9,
    projectInstanceTable,
  },
  props: {
    tableData: {
      type: Object,
      required: true,
      default: () => (
        {
          project_instance: [],
          verra_eq1: [],
          verra_eq4: [],
          verra_eq5: [],
          verra_eq7: [],
          verra_eq9: [],
        }
      ),
    },
    pendingByReport: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    verraEqResult(key) {
      const v = this.tableData[key];
      if (v && typeof v === "object" && Array.isArray(v.result)) {
        return v.result;
      }
      if (Array.isArray(v)) {
        return v;
      }
      return [];
    },
    verraEqUpdatedAt(key) {
      const v = this.tableData[key];
      if (v && typeof v === "object" && v.updated_at != null) {
        return v.updated_at;
      }
      return "";
    },
  },

};
</script>